/* Breeze dynamic Add to Cart savings — compatible with Kaching Bundles */
(function () {
  'use strict';

  var updateTimer = null;
  var observerBusy = false;

  function textOf(el) {
    return String((el && (el.innerText || el.textContent)) || '').replace(/\s+/g, ' ').trim();
  }

  function parseMoney(value) {
    var source = String(value || '').replace(/\u00a0/g, ' ');
    var match = source.match(/(?:([A-Z]{3})\s*)?([£$€¥₹]|R\$|C\$|A\$)?\s*([\d][\d\s.,]*)/i);
    if (!match) return null;

    var raw = match[3].replace(/\s/g, '');
    var lastComma = raw.lastIndexOf(',');
    var lastDot = raw.lastIndexOf('.');
    var decimalMark = null;

    if (lastComma > -1 && lastDot > -1) decimalMark = lastComma > lastDot ? ',' : '.';
    else if (lastComma > -1 && raw.length - lastComma - 1 <= 2) decimalMark = ',';
    else if (lastDot > -1 && raw.length - lastDot - 1 <= 2) decimalMark = '.';

    if (decimalMark) {
      var thousandsMark = decimalMark === ',' ? /\./g : /,/g;
      raw = raw.replace(thousandsMark, '').replace(decimalMark, '.');
    } else {
      raw = raw.replace(/[.,]/g, '');
    }

    var number = Number(raw);
    if (!isFinite(number)) return null;

    return {
      number: number,
      prefix: (match[1] ? match[1] + ' ' : '') + (match[2] || ''),
      decimals: decimalMark && /[.,]\d{1,2}$/.test(match[3].trim()) ? Math.min(2, match[3].trim().split(/[.,]/).pop().length) : 0
    };
  }

  function formatMoney(amount, sample) {
    var prefix = sample && sample.prefix ? sample.prefix : '$';
    var decimals = sample && typeof sample.decimals === 'number' ? sample.decimals : 0;
    var rounded = decimals ? amount.toFixed(decimals) : Math.round(amount).toString();
    if (/\.0{1,2}$/.test(rounded)) rounded = rounded.replace(/\.0{1,2}$/, '');
    return prefix + rounded;
  }

  function directSave(text) {
    var normalized = String(text || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ');
    var match = normalized.match(/(?:you\s+)?save(?:d|s)?\s+(?:over\s+)?((?:(?:[A-Z]{3})\s*)?(?:R\$|C\$|A\$|[£$€¥₹])\s*[\d][\d\s.,]*)/i);
    if (!match) return null;
    var parsed = parseMoney(match[1]);
    if (!parsed || parsed.number <= 0) return null;
    return { amount: parsed.number, label: formatMoney(parsed.number, parsed) };
  }

  function isStruck(el) {
    if (!el || el.nodeType !== 1) return false;
    if (/^(S|DEL)$/i.test(el.tagName)) return true;
    var cls = String(el.className || '');
    if (/compare|was-price|old-price|original-price|strike/i.test(cls)) return true;
    try {
      return /line-through/i.test(window.getComputedStyle(el).textDecorationLine || window.getComputedStyle(el).textDecoration || '');
    } catch (e) {
      return false;
    }
  }

  function savingsFromPrices(scope) {
    if (!scope || !scope.querySelectorAll) return null;
    var all = [];
    var crossed = [];
    var nodes = scope.querySelectorAll('s, del, [class*="compare"], [class*="old-price"], [class*="original-price"], span, div, p');

    for (var i = 0; i < nodes.length; i++) {
      var nodeText = textOf(nodes[i]);
      if (!nodeText || nodeText.length > 45) continue;
      var matches = nodeText.match(/(?:(?:[A-Z]{3})\s*)?(?:R\$|C\$|A\$|[£$€¥₹])\s*[\d][\d\s.,]*/g);
      if (!matches) continue;
      for (var j = 0; j < matches.length; j++) {
        var parsed = parseMoney(matches[j]);
        if (!parsed || parsed.number <= 0) continue;
        all.push(parsed);
        if (isStruck(nodes[i])) crossed.push(parsed);
      }
    }

    if (!crossed.length || all.length < 2) return null;
    var compare = crossed.reduce(function (best, p) { return p.number > best.number ? p : best; }, crossed[0]);
    var currentCandidates = all.filter(function (p) { return p.number < compare.number - 0.001; });
    if (!currentCandidates.length) return null;
    var current = currentCandidates.reduce(function (best, p) { return p.number > best.number ? p : best; }, currentCandidates[0]);
    var amount = compare.number - current.number;
    if (!(amount > 0)) return null;
    return { amount: amount, label: formatMoney(amount, compare) };
  }

  function looksLikeBundleCard(el) {
    if (!el || el === document.body || !el.querySelectorAll) return false;
    var radios = el.querySelectorAll('input[type="radio"]');
    if (radios.length !== 1) return false;
    var text = textOf(el);
    if (text.length > 900) return false;
    return /bundle|pack|each|save/i.test(text) || savingsFromPrices(el);
  }

  function bundleCardForRadio(radio) {
    var el = radio;
    for (var depth = 0; el && el !== document.body && depth < 12; depth++, el = el.parentElement) {
      if (looksLikeBundleCard(el)) return el;
    }
    return null;
  }

  function selectedBundleCard(form) {
    var root = form && form.closest('section, .shopify-section, product-info, .product') || document;
    var checked = root.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      var card = bundleCardForRadio(checked[i]);
      if (card) return card;
    }
    return null;
  }

  function selectedSavings(form) {
    var card = selectedBundleCard(form);
    if (card) {
      var direct = directSave(textOf(card));
      if (direct) return direct;
      var calculated = savingsFromPrices(card);
      if (calculated) return calculated;
    }

    var root = form && form.closest('section, .shopify-section, product-info, .product') || document;
    var rootDirect = directSave(textOf(root));
    if (rootDirect) return rootDirect;
    return savingsFromPrices(root);
  }

  function bagSvg() {
    return '<svg class="bz-btn-icon" aria-hidden="true" viewBox="0 0 448 512" focusable="false"><path fill="currentColor" d="M128 128V96C128 43 171 0 224 0s96 43 96 96v32h48c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48zm48 0h96V96c0-26.5-21.5-48-48-48s-48 21.5-48 48v32zm-16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16zm144 16c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"/></svg>';
  }

  function ensureButtonMarkup(button, savings) {
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    var buttonText = textOf(button);
    if (/sold out|unavailable|esgotado|indisponível/i.test(buttonText)) return;

    var spinner = button.querySelector('.loading-overlay__spinner');
    var inner = button.querySelector('.bz-btn-inner');
    if (!inner) {
      var strong = button.querySelector('strong');
      if (!strong) {
        strong = document.createElement('strong');
        button.insertBefore(strong, spinner || button.firstChild);
      }
      strong.classList.add('bz-btn-inner');
      inner = strong;
    }

    var label = savings && savings.amount > 0 ? '& SAVE ' + savings.label : '';
    var wanted = bagSvg() + '<span class="atctxt">Add to Cart</span>' + (label ? '<span class="atcSaving">' + label + '</span>' : '');
    if (inner.getAttribute('data-bz-content') !== wanted) {
      inner.innerHTML = wanted;
      inner.setAttribute('data-bz-content', wanted);
    }

    /* Some bundle/theme scripts append their own "Add to cart" label after
       updating the button. Keep only our label and the native loading spinner. */
    var children = Array.prototype.slice.call(button.childNodes);
    children.forEach(function (node) {
      if (node === inner || node === spinner) return;

      if (node.nodeType === 3) {
        if (/add\s*to\s*cart/i.test(String(node.nodeValue || '')) || !String(node.nodeValue || '').trim()) {
          node.parentNode.removeChild(node);
        }
        return;
      }

      if (node.nodeType === 1) {
        var cls = String(node.className || '');
        if (/loading-overlay__spinner/.test(cls)) return;
        var duplicateText = textOf(node);
        if (/add\s*to\s*cart/i.test(duplicateText) || node.hasAttribute('data-bz-duplicate-label')) {
          node.parentNode.removeChild(node);
        }
      }
    });
  }

  function updateForm(form) {
    if (!form || !form.querySelector) return;
    var button = form.querySelector('#prodBtnMainAtcc, button[name="add"].product-form__submit, .product-form__submit');
    if (!button) return;
    ensureButtonMarkup(button, selectedSavings(form));
  }

  function updateAll() {
    updateTimer = null;
    observerBusy = true;
    var forms = document.querySelectorAll('product-form form[action*="/cart/add"], form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) updateForm(forms[i]);
    observerBusy = false;
  }

  function schedule(delay) {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(updateAll, typeof delay === 'number' ? delay : 40);
  }

  document.addEventListener('click', function () { schedule(60); }, true);
  document.addEventListener('change', function () { schedule(40); }, true);
  document.addEventListener('input', function () { schedule(40); }, true);
  ['variant:change', 'on:variant:change', 'kaching:bundle:change', 'kaching-bundles:change'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(40); });
  });

  function start() {
    updateAll();
    setTimeout(updateAll, 300);
    setTimeout(updateAll, 900);
    setTimeout(updateAll, 1800);
    setTimeout(updateAll, 3200);

    new MutationObserver(function (mutations) {
      if (observerBusy) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' || mutations[i].type === 'attributes' || mutations[i].type === 'characterData') {
          schedule(70);
          break;
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked', 'aria-selected', 'value']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
